import type { ScheduleEntry } from './schema';

export function localIsoDate(value = new Date()) {
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
}

export function localTime(value = new Date()) {
  return `${String(value.getHours()).padStart(2, '0')}:${String(value.getMinutes()).padStart(2, '0')}`;
}

export function scheduleSort(a: ScheduleEntry, b: ScheduleEntry) {
  const date=(a.date??'9999').localeCompare(b.date??'9999');
  if(date)return date;
  if(a.positioned&&b.positioned&&a.order!==undefined&&b.order!==undefined&&a.order!==b.order)return a.order-b.order;
  return `${a.date ?? '9999'}${a.time ?? '99:99'}${String(a.order ?? 0).padStart(5, '0')}${a.title}`.localeCompare(`${b.date ?? '9999'}${b.time ?? '99:99'}${String(b.order ?? 0).padStart(5, '0')}${b.title}`);
}

export function selectCurrentSchedule(entries: readonly ScheduleEntry[], today = localIsoDate(), departureDate?: string) {
  const open = [...entries].filter((entry) => !entry.completed).sort(scheduleSort);
  const dated = open.filter((entry) => entry.date && entry.date >= today);
  const targetDate = dated.some((entry) => entry.date === today)
    ? today
    : dated[0]?.date;
  if (targetDate) return { targetDate, entries: open.filter((entry) => entry.date === targetDate) };
  const undated = open.filter((entry) => !entry.date);
  if (undated.length) return { targetDate: undefined, entries: undated };
  return { targetDate: departureDate && departureDate >= today ? departureDate : undefined, entries: [] };
}
